const Switches = ({ id, dataid, active, handleChange }: any) => {
  return (
    <>
      <div className="custom-control custom-switch">
        <input
          className="custom-control-input"
          type="checkbox"
          id={id}
          data-dataid={dataid}
          defaultChecked={Boolean(active)}
          onChange={handleChange}
        ></input>
        <label className="custom-control-label" htmlFor={id}></label>
      </div>
    </>
  );
};

export default Switches;
